import './SimpleButton.scss';

interface SimpleButtonProps {
    text: string;
    big: boolean;
    onClick: (e: any) => void;
}

export const SimpleButton = (props: SimpleButtonProps) => {
    let css = "simple-button";

    if (props.big) {
        css += " big-button";
    }

    return (
        <button className={css} onClick={(e) => props.onClick(e)}>{props.text}</button>
    );
}

SimpleButton.defaultProps = {
    big: false,
    onClick: (e: any) => void(0)
}